/* eslint consistent-return: "off" */
import store from '../store';
import { loadUser } from '../modules/api/Auth';

let baseURL = window.location.origin;

if (process.env.PROXY_SERVER_URL) {
  baseURL = process.env.PROXY_SERVER_URL;
}

const guard = (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const teamName = to.params.teamName;
    if (teamName) {
      loadUser(teamName)
       .then(account => store.dispatch('setCurrentUser', account.data))
       .then(() => next());
    } else {
      window.location.href = `${baseURL}/accounts/byteark`;
    }
  } else {
    return next();
  }
};

export default guard;



// WEBPACK FOOTER //
// ./src/router/guard.js